import Slider from './slider';

export default class MiniSlider extends Slider {
    constructor(container, next, prev, activeClass, animate, autoplay) {
        super(container, next, prev, activeClass, animate, autoplay);
    }

    decorizeSlides() {
        // Убираем активный класс у всех слайдов
        this.slides.forEach(slide => {
            slide.classList.remove(this.activeClass);
            if (this.animate) {
                const title = slide.querySelector('.card__title');
                const arrow = slide.querySelector('.card__controls-arrow');
                if (title) title.style.opacity = '0.4';
                if (arrow) arrow.style.opacity = '0';
            }
        });

        // Добавляем активный класс на первый слайд
        if (this.slides[0] && !this.slides[0].closest('button')) {
            this.slides[0].classList.add(this.activeClass);
        }

        // Включаем анимацию для активного слайда
        if (this.animate && this.slides[0]) {
            const title = this.slides[0].querySelector('.card__title');
            const arrow = this.slides[0].querySelector('.card__controls-arrow');
            if (title) title.style.opacity = '1';
            if (arrow) arrow.style.opacity = '1';
        }
    }

    // Переключение на следующий слайд
    nextSlide() {
        const firstSlide = this.slides[0];
        const firstSlideBtn = this.slides[1] && this.slides[1].tagName === 'BUTTON' ? this.slides[1] : null;

        this.container.appendChild(firstSlide);

        if (firstSlideBtn) {
            this.container.appendChild(firstSlideBtn);
        }
        this.slides = Array.from(this.container.children);
        this.decorizeSlides();
    }

    // Переключение на предыдущий слайд
    prevSlide() {
        const lastSlide = this.slides[this.slides.length - 1];
        this.container.insertBefore(lastSlide, this.slides[0]);
        this.slides = Array.from(this.container.children);
        this.decorizeSlides();
    }

    bindTriggers() {
        // Привязываем обработчики событий к стрелкам
        if (this.next) {
            this.next.addEventListener('click', () => this.nextSlide());
        }
        if (this.prev) {
            this.prev.addEventListener('click', () => this.prevSlide());
        }
    }

    init() {
        // Настроим контейнер
        this.container.style.cssText = `
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            align-items: flex-start;
        `;

        // Привязываем события
        this.bindTriggers();
        this.decorizeSlides();

        // Настроим автопроигрывание (если нужно)
        if (this.autoplay) {
            setInterval(() => this.nextSlide(), 5000);
        }
    }
}